export const RECEIPT_ROUTES = {
    index: {
        path: 'receipt/*',
        to: '/receipt/create-receipt',
    },
    receipt: {
        path: 'receipt/*',
        to: '/receipt/create-receipt',
    },
    dashboard: {
        path: 'create-receipt/*',
        to: '/receipt/create-receipt',
    },
    receiptdashboard: {
        path: 'receipt-dashboard/*',
        to: '/receipt/receipt-dashboard',
    },
    pendingreceipt: {
        path: 'pending-receipt/*',
        to: '/receipt/pending-receipt',
    }
};
